import React from "react";
import { FieldSet } from "src/components/event_transaction/components/shared/Form/FieldSet";
import { Text } from "src/components/ui/Text";

const FiscalYearForm = (props) => {
  const { control, disabled } = props;

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-end gap-2">
        <Text variant="bold-14">Fiscal year</Text>
        <Text variant="normal-10">
          Please select the fiscal year of the company
        </Text>
      </div>

      <div className="grid grid-cols-6 gap-2">
        <div className="col-span-1">
          <FieldSet
            required
            disabled={disabled}
            name="fiscalYear.startDate"
            type="datepicker"
            control={control}
            label="Start date"
          />
        </div>
        <div className="col-span-1">
          <FieldSet
            required
            disabled={disabled}
            name="fiscalYear.endDate"
            type="datepicker"
            control={control}
            label="End date"
          />
        </div>
      </div>
    </div>
  );
};

export default FiscalYearForm;
